import { isValidEmail } from './email';
import { NAME_FIELD_MAX } from '../item/newItemForm';
import { CARD_TYPE } from '../cardType/cardTypeModule';


export const isNameValid = (name) => {
    if (name) {
        return name.length <= NAME_FIELD_MAX;
    }
    return true;
};

export const isValidFaceplateCode = faceplateCode => typeof faceplateCode === 'string';

export const isAmountValid = (amount) => {
    if (typeof amount === 'string') {
        return !!amount.match('^[0-9]+\\.?[0-9]{0,2}$');
    }
    return typeof amount === 'number';
};

export const isCardTypeValid = cardType => cardType === CARD_TYPE.PHYSICAL || cardType === CARD_TYPE.DIGITAL;

export const validateName = name => (isNameValid(name) ? name : name.substring(0, NAME_FIELD_MAX));
export const validateEmail = email => (isValidEmail(email) ? email : null);

export const validateFaceplateCode = faceplateCode => (isValidFaceplateCode(faceplateCode) ? faceplateCode : null);

export const validateAmount = amount => (isAmountValid(amount) ? parseFloat(amount) : 0);

export const validateCardType = cardType => (isCardTypeValid(cardType) ? cardType : null);
